import { MedicalHistory, MedicalHistoryControllerApi } from "../../../services";
import { useMutationWithLoading, getConfigObject } from "../../../utils/utils";

type Params = {
  medicalHistory: MedicalHistory;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const usePastMedicationHistoryCreate = () =>
  useMutationWithLoading(async (params: Params) =>
    new MedicalHistoryControllerApi(
      getConfigObject()
    ).createPatientMedicalHistory(params.medicalHistory, params.xTENANTID)
  );
